import { render, staticRenderFns } from "./UserSearchModal.vue?vue&type=template&id=b88efc12&scoped=true"
import script from "./UserSearchModal.vue?vue&type=script&lang=ts"
export * from "./UserSearchModal.vue?vue&type=script&lang=ts"
import style0 from "./UserSearchModal.vue?vue&type=style&index=0&id=b88efc12&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88efc12",
  null
  
)

export default component.exports